import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { PremiumService } from './components/PremiumService';
import { Gallery } from './components/Gallery';
import { OfferBanner } from './components/OfferBanner';
import { LocationContact } from './components/LocationContact';
import { StickyReservation } from './components/StickyReservation';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-charcoal-900 text-cream font-sans selection:bg-gold-500 selection:text-charcoal-900" data-id="element-0">
      <Hero data-id="element-1" />
      <Problem data-id="element-2" />
      <Solution data-id="element-3" />
      <PremiumService data-id="element-4" />
      <Gallery data-id="element-5" />
      <OfferBanner data-id="element-6" />
      <LocationContact data-id="element-7" />
      <Footer data-id="element-8" />
      <StickyReservation data-id="element-9" />
    </div>;
}